import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { inject, observer } from 'mobx-react';
import { colors } from './constants';
import { TwitchIcon } from './TwitchIcon';
import { authService } from '../../../services';
import { SPONSORSHIPS } from '../../../constants';
import { ArrowRightIcon } from './ArrowRightIcon';

const propTypes = {
    classes: PropTypes.object.isRequired
}

const backgroundImages = {
    default: 'https://cdn.streamelements.com/assets/chat-stats-assets/bannerV2/connect_banner_bg.png',
    tablet: 'https://cdn.streamelements.com/assets/chat-stats-assets/bannerV2/connect_banner_bg_tablet.png',
    vertical: 'https://cdn.streamelements.com/assets/chat-stats-assets/bannerV2/connect_banner_bg_mobile.png',
    reversed: 'https://cdn.streamelements.com/assets/chat-stats-assets/bannerV2/connect_banner_bg_reversed.png',
}

@inject('auth', 'store') @observer
class ContinueWithTwitchBanner extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { classes, auth, store } = this.props;
        const { user } = store;
        const connectionPath = auth.isUserLoggedIn ? 'dashboard' : 'twitch';
        const connectionUrl = authService.getConnectionUrl(connectionPath);
        const hasUser = !!user;

        const titleText = hasUser ? 'Level up your creator profile with sponsorships' : 'Super charge your stream';
        const subtitleText = hasUser ? 'No matter the size of your community, get sponsored by reputable brands and take your content to the next level.' : 'Chat Bot | Overlays | Loyalty System | Tipping and Alerts'

        return (
            <div className={hasUser ? classes.hasUserRoot : classes.root}>
                <div className={classes.textWrapper}>
                    <h2 className={classes.title}>{titleText}</h2>
                    <h3 className={classes.subtitle}>{subtitleText}</h3>
                </div>
                <div className={classes.buttonWrapper}>
                    {!hasUser && (
                        <a className={classes.twitchButton} href={connectionUrl}>
                            <TwitchIcon />
                            Continue With Twitch
                        </a>
                    )}
                    {hasUser && (
                        <a className={classes.getSponsoredButton} href={SPONSORSHIPS.URL_SPONSORSHIPS_MULTI}>
                            Get Sponsored
                            <ArrowRightIcon />
                        </a>
                    )}
                </div>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        color: colors.white,
        background: `url(${backgroundImages.default}), ${colors.heroBlue}`,
        backgroundPosition: 'right',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        borderRadius: '8px',
        marginBottom: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '60px',

        '@media (max-width: 1261px)': {
            backgroundSize: 'cover',
        },

        [theme.devices.large]: {
            background: `url(${backgroundImages.tablet}), ${colors.heroBlue}`,
            backgroundSize: 'cover',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },

        [theme.devices.small]: {
            background: `url(${backgroundImages.vertical}), ${colors.heroBlue}`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '40px',
        }
    },
    hasUserRoot: {
        color: colors.white,
        background: `url(${backgroundImages.reversed}), ${colors.heroBlue}`,
        backgroundPosition: 'left',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: '8px',
        marginBottom: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '60px',

        '@media (max-width: 1261px)': {
            backgroundSize: 'cover',
        },

        [theme.devices.large]: {
            background: `url(${backgroundImages.default}), ${colors.heroBlue}`,
            backgroundSize: 'cover',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },

        [theme.devices.small]: {
            background: `url(${backgroundImages.default}), ${colors.heroBlue}`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '40px',
        }
    },
    textWrapper: {
        [theme.devices.large]: {
            marginBottom: '28px',
        },
        [theme.devices.small]: {
            marginBottom: '42px',
        }
    },
    title: {
        fontFamily: 'Doner Semibold',
        fontWeight: 300,
        fontSize: '41px',
        lineHeight: '46px',
        marginBottom: '12px',

        [theme.devices.large]: {
            fontSize: '28px',
            lineHeight: '31px',
        }
    },
    subtitle: {
        fontFamily: 'Work Sans',
        fontSize: '25px',
        lineHeight: 'normal',
        fontWeight: 400,

        [theme.devices.large]: {
            fontSize: '14px',
        }
    },
    twitchButton: {
        cursor: 'pointer',
        background: colors.twitchPurple,
        color: colors.offWhite,
        display: 'flex',
        gap: '21px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '21px 44px',
        border: 'none',
        borderRadius: '73px',
        textTransform: 'uppercase',
        fontFamily: 'Work Sans',
        fontSize: '16px',
        fontWeight: 600,
        textDecoration: 'none'
    },
    buttonWrapper: {
        minWidth: 'fit-content',

        '@media (max-width: 760px)': {
            alignSelf: 'flex-start',
        }
    },
    getSponsoredButton: {
        textDecoration: 'none',
        background: colors.offWhite,
        color: colors.black,
        padding: '20px 42px',
        borderRadius: '70px',
        fontFamily: 'Work Sans',
        fontSize: '20px',
        fontWeight: 600,
        textTransform: 'uppercase',
        display: 'inline-flex',
        gap: '9px',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '100px',

        '@media (max-width: 1261px)': {
            marginLeft: 0,
        },

        [theme.devices.large]: {
            fontSize: '16px',
            lineHeight: '22px',
        },
        '@media (max-width: 760px)': {
            display: 'flex',
            flex: 1
        }
    }
})

ContinueWithTwitchBanner.propTypes = propTypes;

export default injectSheet(styles)(ContinueWithTwitchBanner);



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/ContinueWithTwitchBanner.js